/* The waiting-area display: read from across a room. Paper and ink only. */
.screen {
  box-sizing: border-box;
  min-height: 100vh;
  padding: var(--space-7);
  background: var(--paper);
  color: var(--ink);
  font-family: var(--font-sans);
}

.columns {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: var(--space-8);
}

/* A portrait screen or a small monitor: one column, "Now calling" on top. */
@media (aspect-ratio < 1) or (width < 900px) {
  .screen {
    padding: var(--space-5);
  }

  .columns {
    grid-template-columns: minmax(0, 1fr);
    gap: var(--space-6);
  }
}

.column {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.columnTitle {
  margin: 0;
  padding-bottom: var(--space-3);
  border-bottom: 2px solid var(--ink);
  font-size: 40px;
  font-weight: 600;
  line-height: 1.2;
}

.calls {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  margin: 0;
  padding: 0;
  list-style: none;
}

.call {
  display: flex;
  align-items: baseline;
  gap: var(--space-6);
}

.ticket {
  font-family: var(--font-id);
  font-size: 96px;
  font-weight: 600;
  line-height: 1;
}

.where {
  font-size: 40px;
  line-height: 1.2;
}

.queue {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.queueName {
  margin: 0;
  font-size: 32px;
  font-weight: 600;
  line-height: 1.2;
}

.tickets {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2) var(--space-6);
  margin: 0;
  padding: 0;
  list-style: none;
  font-family: var(--font-id);
  font-size: 40px;
  line-height: 1.3;
}

.quiet,
.message {
  margin: 0;
  color: var(--graphite);
  font-size: 32px;
  line-height: 1.3;
}

.message {
  color: var(--ink);
}
